import React from "react";

interface Props {
  /** When true, renders just the SVG (for table cells, buttons, inline labels).
   *  Default: renders the SVG inside a centered block with reserved vertical space
   *  so first paint is stable and the spinner doesn't jump from top-left to center
   *  as the surrounding layout (sidebar/topbar) finishes hydrating. */
  inline?: boolean;
  /** Pixel size of the SVG itself. Default 36. */
  size?: number;
  /** Minimum block height when not inline. Default 240 — tall enough that a
   *  reflow during hydration doesn't visibly shift the spinner. */
  minHeight?: number;
}

function Svg({ size = 36 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 36 36"
      xmlns="http://www.w3.org/2000/svg"
      style={{ animation: "v-spin 0.9s linear infinite" }}
    >
      <style>{`@keyframes v-spin { to { transform: rotate(360deg); } }`}</style>
      <circle cx="18" cy="18" r="15" fill="none" stroke="#e5e7eb" strokeWidth="3" />
      <circle
        cx="18"
        cy="18"
        r="15"
        fill="none"
        stroke="#4C75AB"
        strokeWidth="3"
        strokeLinecap="round"
        strokeDasharray="70 30"
      />
    </svg>
  );
}

export default function LoadingSpinner({ inline = false, size, minHeight = 240 }: Props) {
  if (inline) return <Svg size={size} />;
  return (
    <div
      className="flex items-center justify-center w-full"
      style={{ minHeight }}
    >
      <Svg size={size} />
    </div>
  );
}
